module.exports = __webpack_public_path__ + "static/media/badge7.5dfff778.svg";